module.exports = __webpack_public_path__ + "static/img/special-day-mobile.df5007e.webp";